import React from "react";
import { Box } from "@mui/material";
import Navbar from "../../Components/Navbar";
import HeroSection from "./HeroSection";
import ApproachSection from "./ApproachSection";
import ArchiveSection from "./ArchiveSection";
import ContactSection from "./ContactSection";
import Footer from "../Home/Footer";
import ScrollToTopButton from "../../Components/ScrollToTopButton";

const InterriorSection = () => {
  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#F9FAFB" }}>
      <Navbar />
      <HeroSection />
      <ApproachSection />
      <ArchiveSection />
      <ContactSection />
      {/* Additional interior design sections can be added here */}
      <Footer />
      <ScrollToTopButton />
    </Box>
  );
};

export default InterriorSection;
